import React from 'react';
import { ScheduleReportTable } from './ScheduleReportTable';
import { AssignedToFilter, DisciplineFilter, PatientFilter, TeamFilter, VisitDateFromFilter, VisitDateToFilter } from '../filters/Filters';
import { useGetSchedulingOptions } from '../filters/useGetSchedulingOptions';
import type { SieveFilterModel } from '~/util/sieve/filter';
import { convertClientDateToServerDate } from '~/util/date';
import { DataTableFilterInjectContextProvider } from '~/shared/data-tables/query/DataTableFilterInjectContext';
import { QueryDataTableFilterBar } from '~/shared/data-tables/query/QueryDataTableFilterBar';
import { FilterBar } from '~/shared/components/filter-bar/FilterBar';

export function ScheduleReport() {
	const { data: options } = useGetSchedulingOptions();
	const currentWeek = options.weeks.find(x => x.currentWeek);
	const defaultFilters: SieveFilterModel[] = [
		{ name: 'visitDateFrom', operator: '>=', value: convertClientDateToServerDate(currentWeek!.startDate) },
		{ name: 'visitDateTo', operator: '<=', value: convertClientDateToServerDate(currentWeek!.endDate) }
	];
	return (
		<div className="space-y-6">
			<DataTableFilterInjectContextProvider defaultFilters={defaultFilters}>
				<QueryDataTableFilterBar>
					<FilterBar.Item label="Team">
						<TeamFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Discipline">
						<DisciplineFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Assigned To">
						<AssignedToFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Patient">
						<PatientFilter />
					</FilterBar.Item>
					<FilterBar.Item label="Visit Date">
						<VisitDateFromFilter />
						<FilterBar.Separator />
						<VisitDateToFilter />
					</FilterBar.Item>
				</QueryDataTableFilterBar>
				<ScheduleReportTable />
			</DataTableFilterInjectContextProvider>
		</div>
	);
}
